<template>
  <td class="text-left">
    <div v-if="item.inventory.images.length"
         class="d-flex w-100 align-items-stretch h-100 position-relative flex-column hover-cursor">
      <div class="w-100 d-flex">
        <img class="thumbnail" :src="getImageSrc(item.inventory.images)"
             @click="showImageGallery(item.inventory)"/>
      </div>
    </div>
    <div v-else
         class="d-flex w-100 align-items-stretch h-100 position-relative flex-column">
      <div class="w-100 d-flex">
        <b-img class="no-img" src="@/assets/no-image-available.png"/>
      </div>
    </div>
  </td>
</template>

<script>
  export default {
    name: "BatchLotUpImageTd",
    props: {
      item: {
        required: true
      }
    },
    methods: {
      getImageSrc(images) {
        for (let img of images) {
          if (img.data && (img.data.thumb || img.data.original)) {
            return img.data.thumb ? img.data.thumb.url : img.data.original.url;
          }
        }
        return null;
      },
      showImageGallery(item) {
        this.$emit("onGalleryClick", {
          items: item.images,
          title: item.short_description
        })
      },
    }
  }
</script>

<style scoped>
  .thumbnail {
    z-index: 0;
    max-width: 60px;
  }

  .no-img {
    max-width: 60px;
  }
</style>
